export default __webpack_public_path__ + "static/media/hospital-escritorio.7c18aae5.svg";